/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_One_SecondInputs */



/**
* | output |
* | --- |
* | "Go back one second in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_One_SecondInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_one_second = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_One_SecondInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_One_SecondInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer d'une seconde dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spulen Sie im Video eine Sekunde zurück.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna indietro di un secondo nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вернитесь на одну секунду назад в видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retroceda un segundo en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频倒退一秒。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画を1秒前に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में एक सेकंड पीछे जाइए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Volte um segundo no vídeo.")
	return /** @type {LocalizedString} */ ("Go back one second in the video")
});